// extracted by mini-css-extract-plugin
export var content = "_7k-3";
export var list = "_7k-4";
export var settingsContent = "_7k-7";
export var settingsPanel = "_7k-8";
export var state = "_7k-6";
export var triggerBadge = "_7k-2";
export var triggerButton = "_7k-1";
export var triggerShell = "_7k-0";
export var unreadDot = "_7k-5";